import React from 'react';
import PalletList from '../../components/Pallets/PalletList';

const PalletsPage: React.FC = () => {
    return (
        <div className="customers-page">
            <PalletList />
        </div>
    );
};

export default PalletsPage; 